export default "__VITE_ASSET__b42af989__"